// extracted by mini-css-extract-plugin
export var createdDate = "_mi-1";
export var divider = "_mi-2";
export var headerDivider = "_mi-3";
export var messagesCard = "_mi-0";
export var messagesContainer = "_mi-7";
export var messagesContainerWrapper = "_mi-4";
export var pointerCapturingButtonBoxes = "_mi-a";
export var showLeftPanelButton = "_mi-9";
export var showMoreButton = "_mi-c";
export var showMoreButtonContainer = "_mi-b";
export var summaryTitle = "_mi-6";
export var systemMessageCardWrapper = "_mi-d";
export var topButtons = "_mi-8";
export var withPadding = "_mi-5";